// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('../../styles//GlobalStyles.css'); */

.footer-container {
    width: 100%;
    /* height: 67px; */
    background-color: var(--field-background);
    /* border: 1px solid red; */
    display: flex;
    align-items: center;
    padding-left: 40px;
    padding-top: 24px;
    padding-bottom: 17px;
    /* position: absolute;
    bottom: 0px; */
    position: fixed;
    bottom: 0;

    width: calc(100% - 290px);
    right: 0;
    z-index: 10;
}

.footer-container>p {
    color: var(--placeholder-grey);
    font-family: var(--inter-Medium500);
    font-size: 14px;
    /* line-height: 24px; */
    letter-spacing: -0.28px;
}`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;IACI,WAAW;IACX,kBAAkB;IAClB,yCAAyC;IACzC,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;kBACc;IACd,eAAe;IACf,SAAS;;IAET,yBAAyB;IACzB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,mCAAmC;IACnC,eAAe;IACf,uBAAuB;IACvB,uBAAuB;AAC3B","sourcesContent":["/* @import url('../../styles//GlobalStyles.css'); */\n\n.footer-container {\n    width: 100%;\n    /* height: 67px; */\n    background-color: var(--field-background);\n    /* border: 1px solid red; */\n    display: flex;\n    align-items: center;\n    padding-left: 40px;\n    padding-top: 24px;\n    padding-bottom: 17px;\n    /* position: absolute;\n    bottom: 0px; */\n    position: fixed;\n    bottom: 0;\n\n    width: calc(100% - 290px);\n    right: 0;\n    z-index: 10;\n}\n\n.footer-container>p {\n    color: var(--placeholder-grey);\n    font-family: var(--inter-Medium500);\n    font-size: 14px;\n    /* line-height: 24px; */\n    letter-spacing: -0.28px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
